<template>
  <div v-if="primaryOptions?.length" class="mt-4">
    {{ $t("profiles.labels.primarySale") }}
    <div
      v-for="option in primaryOptions"
      :key="option.id"
      class="w-full flex my-3 justify-start items-center cursor-pointer md:rounded-lg"
      :class="
        !isProfile
          ? 'external-link-container py-6 px-[30px] space-x-2'
          : 'md:py-5 lg:px-7 px-0 py-3'
      "
      @click="navigate(option)"
    >
      <img
        :class="
          isProfile
            ? 'h-[38px] w-[38px] rounded-full mr-[18px]'
            : 'h-8 w-12 logo'
        "
        :src="getImage(option)"
        :alt="`${option.name} logo`"
        @error="
          $event.target.src = require('@/assets/images/placeholder-event.svg')
        "
      />
      <div
        class="flex max-w-[195px] md:max-w-full"
        :class="isProfile ? 'md:flex-row flex-col md:items-center' : 'flex-col'"
      >
        <h3
          class="md:max-w-[714px]"
          :class="[
            isProfile
              ? 'lg:text-[20px] md:text-base text-[12px]'
              : 'md:text-l text-[12px]',
            { 'flex flex-col': !option.name && !isProfile }
          ]"
        >
          <span
            v-if="option.aggregator && option.aggregator.company_name"
            :class="{ 'font-semibold': isProfile }"
          >
            {{ option.aggregator.company_name }}
          </span>

          <span
            v-if="
              (isProfile && Number(option.price) !== 0) ||
                Number(option.name) !== 0
            "
            class=""
            :class="[
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-l text-[12px]',
              {
                'inline-block': isProfile && option.name
              }
            ]"
          >
            -
          </span>
          <span
            v-if="option.name"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-l text-[12px]'
            "
            >{{ option?.name }}
            <span
              v-if="option.name && Number(option.price) !== 0"
              :class="{ 'lg:text-[20px] md:text-base text-[12px]': isProfile }"
            >
              -
            </span>
          </span>
          <span
            v-if="Number(option.price) !== 0"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-greenStatus md:text-l text-[12px]'
            "
          >
            {{ formatCurrency(option.price, option.currency) }}
          </span>
        </h3>
      </div>

      <wegow-button
        v-if="isProfile"
        class="pay-btn ml-auto"
        :text="$t('wegow.purchase.buy')"
        size="external-btn"
        color="topaz-light"
        background="opacity"
        :disabled="loading"
        :style="getPersonalizedButton"
        @click="navigateTo(option)"
      >
      </wegow-button>
    </div>
  </div>
  <div v-if="bookingOptions?.length" class="mt-4">
    <h3>{{ $t("wegow.purchase.bookingOptions") }}</h3>
    <div
      v-for="option in bookingOptions"
      :key="option.id"
      class="w-full flex my-3 justify-start items-center cursor-pointer md:rounded-lg"
      :class="
        !isProfile
          ? 'external-link-container space-x-2'
          : 'md:py-5 lg:px-7 px-0 py-3'
      "
      @click="navigate(option)"
    >
      <img
        :class="
          isProfile
            ? 'h-[38px] w-[38px] rounded-full mr-[18px]'
            : 'h-8 w-12 logo'
        "
        :src="getImage(option)"
        :alt="`${option.name} logo`"
        @error="
          $event.target.src = require('@/assets/images/placeholder-event.svg')
        "
      />
      <div
        class="flex"
        :class="isProfile ? 'md:flex-row flex-col md:items-center' : 'flex-col'"
      >
        <h3
          v-if="option.aggregator && option.aggregator.company_name"
          :class="
            isProfile
              ? 'md:text-[20px] md:text-base text-[12px] font-semibold'
              : 'md:text-l text-[12px]'
          "
        >
          {{ option.aggregator.company_name }}
        </h3>
        <span
          v-if="isProfile && option.name"
          :class="
            isProfile
              ? 'lg:text-[20px] md:text-base text-[12px] md:block hidden'
              : 'md:text-l text-[12px]'
          "
        >
          -
        </span>
        <div class="flex">
          <span
            v-if="option.name"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-l text-[12px]'
            "
            >{{ option?.name }}</span
          >
          <span
            v-if="option.name && Number(option.price) !== 0"
            :class="{ 'lg:text-[20px] md:text-base text-[12px]': isProfile }"
          >
          </span>
          <span
            v-if="Number(option.price) !== 0"
            class="md:text-greenStatus"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-greenStatus md:text'
            "
          >
            {{ formatCurrency(option.price, option.currency) }}
          </span>
        </div>
      </div>
      <wegow-button
        v-if="isProfile"
        class="pay-btn ml-auto"
        :text="$t('wegow.purchase.buy')"
        size="external-btn"
        color="topaz-light"
        background="opacity"
        :disabled="loading"
        :style="getPersonalizedButton"
        @click="navigateTo(option)"
      >
      </wegow-button>
    </div>
  </div>
  <div v-if="secondaryOptions?.length" class="mt-4">
    {{ $t("profiles.labels.secondarySale") }}
    <div
      v-for="option in secondaryOptions"
      :key="option.id"
      class="w-full flex my-3 justify-start items-center cursor-pointer md:rounded-lg"
      :class="
        !isProfile
          ? 'external-link-container space-x-2'
          : 'md:py-5 lg:px-7 px-0 py-3'
      "
      @click="navigate(option)"
    >
      <img
        :class="
          isProfile
            ? 'h-[38px] w-[38px] rounded-full mr-[18px]'
            : 'h-8 w-12 logo'
        "
        :src="getImage(option)"
        :alt="`${option.name} logo`"
        @error="
          $event.target.src = require('@/assets/images/placeholder-event.svg')
        "
      />
      <div
        class="flex"
        :class="isProfile ? 'md:flex-row flex-col md:items-center' : 'flex-col'"
      >
        <span
          v-if="option.aggregator && option.aggregator.company_name"
          :class="isProfile ? 'font-semibold' : 'md:text-l text-[12px]'"
        >
          {{ option.aggregator.company_name }}
        </span>
        <span
          v-if="isProfile && option?.aggregator?.company_name"
          :class="
            isProfile
              ? 'lg:text-[20px] md:text-base text-[12px] md:block hidden'
              : 'md:text-xl text-[12px]'
          "
        >
          <span>&nbsp;-&nbsp;</span>
        </span>
        <div class="flex items-center">
          <span
            v-if="option?.name"
            :class="{ 'lg:text-[20px] md:text-base text-[12px]': isProfile }"
            >{{ option.name }}</span
          >
          <span
            v-if="option.name && Number(option.price) !== 0"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-l text-[12px]'
            "
          >
            -
          </span>
          <span
            v-if="Number(option.price) !== 0"
            :class="
              isProfile
                ? 'lg:text-[20px] md:text-base text-[12px]'
                : 'md:text-greenStatus md:text-l text-[12px]'
            "
          >
            {{ formatCurrency(option.price, option.currency) }}
          </span>
        </div>
      </div>
      <wegow-button
        v-if="isProfile"
        class="pay-btn ml-auto"
        :text="$t('wegow.purchase.buy')"
        size="external-btn"
        color="topaz-light"
        background="opacity"
        :disabled="loading"
        :style="getPersonalizedButton"
        @click="navigateTo(option)"
      >
      </wegow-button>
    </div>
  </div>

  <!-- <div class="w-full flex items-center">
    <img
      id="info-external-links"
      class="h-8 w-8"
      alt="info icon"
      :src="require('@/assets/images/ic-info.svg')"
    />
    <span class="subtitle ml-4"> {{ $t("wegow.purchase.externalInfo") }}</span>
  </div> -->
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";
import WegowButton from "@/components/general/forms/WegowButton";

import { formatCurrency } from "@/plugins/currency";
import { onMounted, onBeforeUnmount, ref, watch } from "vue";
import { event } from "vue-gtag";
import axios from "axios";
import { useUserStore } from "@/stores/modules/user";
import { useStatsStore } from "@/stores/modules/stats";
import { useRoute } from "vue-router";
import apiService from "@/api/ApiService";

const { details: eventDetail } = useEvent();

const route = useRoute();

const props = defineProps({
  isProfile: {
    type: Boolean,
    default: false
  }
});

const primaryOptions = ref([]);
const bookingOptions = ref([]);
const secondaryOptions = ref([]);
const windowWidth = ref(window.innerWidth);
const emit = defineEmits(["primary"]);

const userStore = useUserStore();
const statsStore = useStatsStore();

onMounted(() => {
  window.addEventListener("resize", updateScreen);
  eventDetail.value.options.forEach(option => {
    if (option.aggregator && option.aggregator.market === 0) {
      primaryOptions.value.push(option);
    } else if (option.aggregator && option.aggregator.market === 2) {
      bookingOptions.value.push(option);
    } else {
      secondaryOptions.value.push(option);
    }
  });
  emit("primary", primaryOptions.value);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", updateScreen);
});
const updateScreen = () => {
  windowWidth.value = window.innerWidth;
};
const navigate = option => {
  if (!props.isProfile || (props.isProfile && windowWidth.value < 768)) {
    navigateTo(option);
  }
};

const getImage = option => {
  if (option.aggregator?.image_url) {
    return option.aggregator.image_url;
  }
  return require("@/assets/images/placeholder-event.svg");
};
const gaEvent = option => {
  event("external_sell", {
    event_name: eventDetail.value.title,
    spider_name: option?.aggregator?.name || option?.name || "",
    post_category: "affiliates"
  });
};

const sendPixelData = async option => {
  let ttid = sessionStorage;
  const pixelData = {
    option: option,
    ssPlatform: ttid.tt_appInfo,
    ssId: userStore.userDetail.unsubscribe_token
      ? userStore.userDetail.unsubscribe_token
      : ttid.tt_sessionId
  };
  const params = {
    campaign: "affiliate-click",
    id: pixelData.ssId,
    option_name: option.name,
    aggregate_name: option.aggregator.name,
    event_id: option.event,
    currency: option.currency,
    price: option.price,
    url: option.url,
    option_id: option.id
  };
  await statsStore.sendToStatsService(params);
};

const followArtist = async () => {
  const params = {
    artist:
      eventDetail.value?.artists.length > 0
        ? eventDetail.value?.artists[0]?.id
        : null
  };
  try {
    await apiService.post("/user_artists/", params);
  } catch (error) {
    console.log("error :>> ", error);
  }
};

const followVenue = async () => {
  const params = {
    venue: eventDetail.value.venue.id
  };
  try {
    await apiService.post("/user_venues/", params);
  } catch (error) {
    console.log("error :>> ", error);
  }
};

const navigateTo = async option => {
  gaEvent(option);
  await followVenue();
  await followArtist();
  // await sendPixelData(option);
  window.location.href = option.url;
};
watch(
  windowWidth,
  newWidth => {
    updateScreen();
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
.external-link-container {
  background-color: $backgroundGrey;
  padding: 24px 30px;
  .logo {
    height: 71px;
    width: 71px;
    object-fit: content;
    border-radius: 5px;
  }
}
// .subtitle {
//   color: $textSubtitle;
// }
</style>
